import axios from "axios";
import axiosRetry from 'axios-retry';
import { requestWithCache } from "./CacheService";

axiosRetry(axios, { retries: Number(process.env.GATSBY_WEBSITE_API_RETRY_COUNT || 3), shouldResetTimeout: true });

async function post<T>(url: string, data, config = {}): Promise<T> {
    const response = await axios.post<T>(url, data, config);
    return response.data;
}

async function get<T>(url: string, cacheKey = '', config: any = {}): Promise<T> {
    let newConfig;
    // For all requests from preview env pass isPreview=true in the url
    if (process.env.GATSBY_BUILD_IS_PREVIEW === 'true' || process.env.MACUCOM_APPLICATION === 'buildr') {
        newConfig = {
            ...config,
            params: {
                isPreview: true,
                ...config?.params,
            },
        };
    } else {
        newConfig = config;
    }
    return requestWithCache(() => axios.get<T>(url, newConfig).then(res => res.data), cacheKey);
}

const HttpService = {
    post,
    get
};

export default HttpService;